import PasswordField from "../common/PasswordField";
import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthCardLayout from "./AuthCardLayout";

interface LoginFormProps {
  onSignIn: (identifier: string, password: string) => Promise<boolean>;
  isLoading: boolean;
  error: string | null;
}

export default function LoginForm({ onSignIn, isLoading, error }: LoginFormProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [identifier, setIdentifier] = React.useState("");
  const [password, setPassword] = React.useState("");

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!identifier || !password) return;
    onSignIn(identifier, password);
  };

  return (
    <AuthCardLayout title={t("auth.loginTitle")}>
      <Box component="form" noValidate onSubmit={handleSubmit} sx={{ width: "100%" }}>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          margin="normal"
          required
          fullWidth
          id="identifier"
          label={t("auth.emailOrPhone")}
          name="identifier"
          autoComplete="username"
          autoFocus
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
        />
        <PasswordField
          margin="normal"
          required
          fullWidth
          name="password"
          label={t("auth.password")}
          id="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
          <Link component="button" type="button" variant="body2" onClick={() => navigate("/forgot-password")}>
            {t("auth.forgotPassword")}
          </Link>
        </Box>
        <Button type="submit" fullWidth variant="contained" disabled={isLoading} sx={{ mt: 3, mb: 2 }}>
          {isLoading ? <CircularProgress size={24} color="inherit" /> : t("auth.signIn")}
        </Button>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Link component="button" type="button" variant="body2" onClick={() => navigate("/register")}>
            {t("auth.noAccount")}
          </Link>
        </Box>
      </Box>
    </AuthCardLayout>
  );
}
